var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{ active: _vm.active, disabled: _vm.disabled },on:{"click":_vm.set}},[_c('div',{staticClass:"box"},[_c('g-icon',{attrs:{"name":"ui/check"}})],1),_c('div',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }